export const CONFIG_DATA = 'CONFIG_DATA';
export const SET_ACTID = 'SET_ACTID';


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/receiveFree/store/types.js